import React from 'react';

function FunFacts() {
    return(
        <div class="container pt-5 my-5" id="FunFacts">
            <div class="row">
                <div class="col">
                    <span class="border border-dark">
                        <img src="https://images.unsplash.com/photo-1535365752810-1bc1ebcc98c7?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=627&q=80" alt="library" height="50%"/>
                    </span>
                </div>
                <div class="col">
                    <h1><br/><br/>Fun Facts</h1>
                    <ul>
                        <li>I like cherry coke</li>
                        <li>I like to go thrifting</li>
                        <li>I enjoy watching NCIS</li>
                        <li>My spirit animal is Linus Tech Tips</li>
                        <li>Notion is great!</li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default FunFacts